var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"body-overlay",class:{ opened: _vm.opened },on:{"click":_vm.close}})
}
var staticRenderFns = []

export { render, staticRenderFns }